import { QuestionCircleOutlined } from '@ant-design/icons';
import { Link, SelectLang as UmiSelectLang, useIntl } from '@umijs/max';
import { Tooltip } from 'antd';
import { useEffect, useState } from 'react';

export type SiderTheme = 'light' | 'dark';

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Question: React.FC = () => {
  const intl = useIntl();
  return (
    <Link
      to="/account/help"
      className="flex items-center"
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <Tooltip title={intl.formatMessage({ id: 'menu.account.help' })}>
        <QuestionCircleOutlined />
      </Tooltip>
    </Link>
  );
};
// utc0时间
export const UtcTime: React.FC = () => {
  const [currentTime, setCurrentTime] = useState<string>('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      const year = now.getUTCFullYear();
      const month = String(now.getUTCMonth() + 1).padStart(2, '0');
      const day = String(now.getUTCDate()).padStart(2, '0');
      const hours = String(now.getUTCHours()).padStart(2, '0');
      const minutes = String(now.getUTCMinutes()).padStart(2, '0');
      const seconds = String(now.getUTCSeconds()).padStart(2, '0');

      setCurrentTime(`${year}-${month}-${day} ${hours}:${minutes}:${seconds} UTC+0`);
    };

    // 立即更新一次
    updateTime();

    // 每秒更新一次
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <span
      style={{
        fontSize: '14px',
        color: '#666',
        fontFamily: 'monospace',
      }}
    >
      {currentTime}
    </span>
  );
};
